import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledCard = styled.div`
  padding: 40px 24px 24px;
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.medium')};
  box-shadow: ${themeGet('shadows.card')};
`;

export const StyledGreenCoin = styled.div`
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const StyledGreenCoinMount = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: ${themeGet('fontSizes.md')}px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.text.default')};
`;

export const StyledValue = styled.div`
  font-size: 22px;
  text-align: center;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.primary.extra')};

  &:not(:last-child) {
    margin-bottom: 47px;
  }
`;

export const StyledFlexGrow = styled.div`
  flex-grow: 1;
  min-height: 96px;

  &:not(:last-child) {
    margin-bottom: 17px;
  }
`;
